<div class="container" *ngIf="isVisible">
    <div class="head">
        <div class="head-label">{{'MENU.ALLERGEN_GROUP.HEADER' | translate}}
        </div>
        <mat-icon class="head-exit" (click)="onClose()">close</mat-icon>
    </div>
    <form [formGroup]="form">

        <div class="image-field-wrapper">
            <app-select-image-field
                    [allowOverrides]="allowOverrides"
                    [image]="selectedAllergenGroupImgSrc"
                    [originalUrl]="originalAllergenGroup.externalPictureUrl"
                    [overrideUrl]="allergenGroup.externalPictureUrl"
                    [organizationId]="organization.id"
                    (imageChanged)="onImageChanged($event)"
            ></app-select-image-field>
            <button
                    *ngIf="canHaveOverrides() && isPictureDifferent()"
                    mat-icon-button
                    class="restore-button"
                    matTooltip="{{ 'COMMON.RESTORE' | translate }}"
                    (click)="restorePicture($event)"
            >
                <mat-icon>restore</mat-icon>
            </button>
        </div>

        <mat-form-field class="dish-name" appearance="fill">
            <mat-icon *ngIf="canHaveOverrides() && isFieldDifferent('allergenGroupName', originalAllergenGroup.name)" matSuffix (click)="restoreField($event, 'allergenGroupName', originalAllergenGroup.name)">restore</mat-icon>
            <mat-label>{{'MENU.ALLERGEN_GROUP.NAME' | translate}}</mat-label>
            <input matInput type="text" formControlName="allergenGroupName" [class.isDifferent]="canHaveOverrides() && isFieldDifferent('allergenGroupName', originalAllergenGroup.name)">
            <label class="error" *ngIf="form.hasError('allergenGroupName')">{{form.errors['allergenGroupName']}}</label>
        </mat-form-field>

        <div *ngIf="organization.additionalLanguages">
            <mat-form-field class="dish-name" appearance="fill"
                            *ngFor="let lang of organization.additionalLanguages">
                <mat-icon *ngIf="canHaveOverrides() && isTranslationDifferent(lang)" matSuffix (click)="restoreTranslation($event, lang)">restore</mat-icon>
                <mat-label>{{ 'MENU.ALLERGEN_GROUP.TRANSLATION' | translate }} {{ lang }}</mat-label>
                <input matInput type="text" formControlName="{{lang}}" [class.isDifferent]="canHaveOverrides() && isTranslationDifferent(lang)">
            </mat-form-field>
        </div>

        <mat-form-field class="dish-name" appearance="fill">
            <mat-icon *ngIf="canHaveOverrides() && isFieldDifferent('textColor', originalAllergenGroup.textColor ?? '')" matSuffix (click)="restoreField($event, 'textColor', originalAllergenGroup.textColor ?? '')">restore</mat-icon>
            <mat-label>{{'MENU.TEXT_COLOR' | translate}}</mat-label>
            <input matInput type="text" formControlName="textColor" [class.isDifferent]="canHaveOverrides() && isFieldDifferent('textColor', originalAllergenGroup.textColor ?? '')">
        </mat-form-field>

        <mat-form-field class="dish-name" appearance="fill">
            <mat-icon *ngIf="canHaveOverrides() && isFieldDifferent('backgroundColor', originalAllergenGroup.backgroundColor ?? '')" matSuffix (click)="restoreField($event, 'backgroundColor', originalAllergenGroup.backgroundColor ?? '')">restore</mat-icon>
            <mat-label>{{'MENU.BACKGROUND_COLOR' | translate}}</mat-label>
            <input matInput type="text" formControlName="backgroundColor" [class.isDifferent]="canHaveOverrides() && isFieldDifferent('backgroundColor', originalAllergenGroup.backgroundColor ?? '')">
        </mat-form-field>

        <div>
            <mat-form-field>
                <span>{{ 'MENU.ALLERGEN_GROUP.CODE' | translate }} </span>
                <input matInput type="text" [value]="allergenGroup.code ?? ''" disabled/>
            </mat-form-field>

            <span>
        <span>{{ 'MENU.ALLERGEN_GROUP.IS_MANUALLY_CREATED' | translate }}</span>
        <input type="checkbox" formControlName="isManuallyCreated"/>
      </span>
        </div>

        <div *ngIf="canHaveOverrides()" class="section-selector">
            <div class="section-selector-header">
                <mat-checkbox
                        [checked]="selectAllChecked"
                        [indeterminate]="selectedSectionIds.size > 0 && !selectAllChecked"
                        (change)="toggleSelectAll()"
                >
                    {{ (selectAllChecked ? 'MENU.DESELECT_ALL' : 'MENU.SELECT_ALL') | translate }}
                </mat-checkbox>
            </div>
            <div class="section-list">
                <div *ngFor="let section of menuSections" class="section-item">
                    <mat-checkbox
                            [checked]="selectedSectionIds.has(section.id)"
                            (change)="toggleSection(section.id)"
                    >
                        {{ section.name }}
                    </mat-checkbox>
                </div>
            </div>
        </div>

        <div class="form-bottom">
            <button
                    class="form-bottom-button"
                    mat-button
                    type="submit"
                    (click)="submit()"
            >{{ 'MENU.SAVE' | translate }}
            </button>

            <button
                    *ngIf="isManuallyCreated()"
                    mat-button
                    type="button"
                    (click)="deleteItem()"
                    class="form-bottom-button"
            >{{ 'MENU.DELETE' | translate }}
            </button>
        </div>
    </form>
</div>
